import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { NavigationLinkButton, Header, Paragraph } from "../../components/RegularComponents";

export const ComplianceOfficerNo = (props) => {
  const dispatch = useDispatch();

  //const [applicationSaveError, setApplicationSaveError] = useState(false);


  const backToStart = () => {
    dispatch(push(`${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_PRIVACY_NOTICE}`));
  };

  return (
    <div className="container">
      {/* Title */}

      <div className="row">
        <div className="col-lg-8">
          <Header
            id="rjsc-detail-review-header"
            header={"Choose a new compliance officer"}
          />
          <Paragraph
            id="rjsc-detail-review-text"
            text={[
              'Choose a compliance officer at your company making sure that they are a partner, director, or officer at the company',
              'The compliance officer is only person who can apply for a Mortgage Lender licence'
            ]}
          />
        </div>
      </div>

      {/* Back to start */}
      <div className="row">
        <div className="col-lg-2">
          <NavigationLinkButton
            style={{paddingLeft: "0px"}}
            text="Back to start"
            onClick={backToStart}

          />
        </div>
      </div>
    </div>
  );
};
